export const defaultJournal = {
  lunes: {
    start_workday: "00:00:00",
    end_workday: "00:00:00",
  },
  martes: {
    start_workday: "00:00:00",
    end_workday: "00:00:00",
  },
  miercoles: {
    start_workday: "00:00:00",
    end_workday: "00:00:00",
  },
  jueves: {
    start_workday: "00:00:00",
    end_workday: "00:00:00",
  },
  viernes: {
    start_workday: "00:00:00",
    end_workday: "00:00:00",
  },
  sabado: {
    start_workday: "00:00:00",
    end_workday: "00:00:00",
  },
  domingo: {
    start_workday: "00:00:00",
    end_workday: "00:00:00",
  },
};
